import apiUseCases from "@src/cloud-connect/api";
import { parseAxiosApiError } from "@src/cloud-connect/utils/parse-axios-api-error";
import store from "@src/reducers/store";
import { ZitadelUser } from "@src/types/user-management";

export const getVPNSingleUserUseCase = async (
  userId: string,
  namespace?: string,
): Promise<{
  success: boolean;
  data?: ZitadelUser;
  error?: string;
}> => {
  try {
    const namespaceToUse = namespace
      ? namespace
      : store.getState().yourSlice.authContext.customerNamespace;
    const response = await apiUseCases.getUserById(namespaceToUse, userId);

    return {
      success: true,
      data: response.data,
    };
  } catch (error) {
    return {
      success: false,
      error: parseAxiosApiError(error, "Failed to fetch single user.").message,
    };
  }
};
